import React, { ReactElement } from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';

interface CompetencyProgressBarProps {
  label: string;
  hours: string;
  events: number;
  progress: number; // 0-100
  color: string;
}

export const CompetencyProgressBar = ({
  label,
  hours,
  events,
  progress,
  color,
}: CompetencyProgressBarProps): ReactElement => {
  return (
    <Box
      sx={{
        marginBottom: '12px',
        border: '1px solid #E8E8E8',
        padding: '16px',
      }}
    >
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 600,
          color: '#1F1F1F',
          marginBottom: '12px',
        }}
      >
        {label}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: '8px',
          borderRadius: '4px',
          backgroundColor: '#E8E8E8',
          '& .MuiLinearProgress-bar': {
            backgroundColor: color,
            borderRadius: '4px',
          },
        }}
      />
      <Typography
        sx={{
          fontSize: '12px',
          color: '#6B6B6B',
          textAlign: 'left',
          marginTop: '8px',
        }}
      >
        {hours} · {events} events
      </Typography>
    </Box>
  );
};
